import { Product, Topping, User } from './types';

export const CURRENT_USER: User = {
  name: "Sophie M.",
  points: 340,
  status: "Gold",
  avatar: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop"
};

export const PRODUCTS: Product[] = [
  {
    id: "p1",
    name: "Mango Pomelo Sago",
    description: "Fresh mango chunks, pomelo pulp, and sago pearls in a creamy coconut milk base.",
    price: 6.50,
    category: "fruit-tea",
    image: "https://images.unsplash.com/photo-1525385133512-2f3bdd039054?q=75&w=720&auto=format&fit=crop",
    tags: ["Bestseller", "New"],
    stock: 'in-stock'
  },
  {
    id: "p2",
    name: "Brown Sugar Milk Tea",
    description: "Fresh milk with our signature roasted brown sugar syrup and warm tapioca pearls.",
    price: 5.50,
    category: "milk-tea",
    image: "https://images.unsplash.com/photo-1558857563-b371033873b8?q=80&w=800&auto=format&fit=crop",
    tags: ["Bestseller"],
    stock: 'in-stock'
  },
  {
    id: "p3",
    name: "Matcha Red Bean",
    description: "Premium Japanese Matcha green tea served with sweet red beans.",
    price: 7.20,
    category: "matcha",
    image: "https://images.unsplash.com/photo-1751033390130-cdc5a6082089?q=80&w=800&auto=format&fit=crop",
    stock: 'low-stock'
  },
  {
    id: "p4",
    name: "Passion Fruit Burst",
    description: "Tart and sweet passion fruit jam shaken with ice cold jasmine green tea.",
    price: 5.75,
    category: "fruit-tea",
    image: "https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?q=80&w=800&auto=format&fit=crop",
    stock: 'in-stock'
  },
  {
    id: "p5",
    name: "Taro Coconut Latte",
    description: "Double dose of creamy taro and coconut milk. Perfect for winter.",
    price: 6.00,
    category: "milk-tea",
    image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?q=80&w=800&auto=format&fit=crop",
    stock: 'out-of-stock'
  },
  {
    id: "s1",
    name: "Matcha Cookie",
    description: "Soft center cookie with matcha and white chocolate.",
    price: 2.50,
    category: "snack",
    image: "https://images.unsplash.com/photo-1605292356183-a77d0a9c9d1d?q=80&w=800&auto=format&fit=crop",
    tags: ["Promo"],
    stock: 'in-stock'
  },
  {
    id: "s2",
    name: "Egg Waffle",
    description: "Crispy Hong Kong style egg waffle.",
    price: 4.00,
    category: "snack",
    image: "https://images.unsplash.com/photo-1589119908995-c6837fa14848?q=80&w=800&auto=format&fit=crop",
    stock: 'in-stock'
  },
  {
    id: "s3",
    name: "Mochi Ice Cream",
    description: "Duo of mango and green tea mochi.",
    price: 3.80,
    category: "snack",
    image: "https://plus.unsplash.com/premium_photo-1701104846200-9cbfccc8a457?q=80&w=800&auto=format&fit=crop",
    stock: 'in-stock'
  }
];

export const TOPPINGS: Topping[] = [
  { id: "t1", name: "Perles de tapioca", price: 0.50, image: "⚫", available: true },
  { id: "t2", name: "Flan aux œufs", price: 0.50, image: "🍮", available: true },
  { id: "t3", name: "Aloe Vera", price: 0.50, image: "🧊", available: false },
  { id: "t4", name: "Gelée de coco", price: 0.50, image: "🥥", available: true },
  { id: "t5", name: "Haricot rouge", price: 0.50, image: "🫘", available: true },
];
